import {
  makeNullSafeDomainGetter,
  featuredMortgageOfficeDomainSelector,
  createIsLoadingSelector,
} from 'store/state/domainData/selectors/common';

export const featuredMortgageOfficeSelector = makeNullSafeDomainGetter(featuredMortgageOfficeDomainSelector, 'getRandomFeaturedMortgageAdvisorsOffice', true);
export const featuredMortgageOfficeLoadingSelector = createIsLoadingSelector(featuredMortgageOfficeDomainSelector);
